"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRedirectToPdp = void 0;
var _react = require("react");
const origin = '&origin=';
const getPdpUrl = ({
  placement,
  product: {
    id,
    url
  }
}) => {
  if (url) {
    return `${url}${origin}${placement}`;
  }
  return `${window.location.origin}/products/product?code=${id}${origin}${placement}`;
};
const useRedirectToPdp = ({
  placement
}) => {
  const timeout = (0, _react.useRef)();
  (0, _react.useEffect)(() => () => clearTimeout(timeout.current));
  return (0, _react.useCallback)(({
    product,
    delay = 0,
    newTab
  }) => {
    const url = getPdpUrl({
      placement,
      product
    });
    const redirect = () => newTab ? window.open(url, '_blank') : window.location.assign(url);
    timeout.current = setTimeout(redirect, delay);
  }, [placement]);
};
exports.useRedirectToPdp = useRedirectToPdp;
